import { render, staticRenderFns } from "./service_requests.vue?vue&type=template&id=ee37bd80&"
import script from "./service_requests.vue?vue&type=script&lang=js&"
export * from "./service_requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports